<div class="container d-flex align-items-center text-center vh-100">
    <div class="mx-auto">
        <h1 style="font-family: Cherry Bomb One, serif; color: #ed6113">Oops !</h1>
        <img alt="Not Found" src="/assets/images/404_gif.gif" class="img-fluid img-center" />
        <h1 style="font-family: Cherry Bomb One, serif; color: #ed6113">We can't seem to find the page you're looking for.</h1>
        <h1 style="font-family: Cherry Bomb One, serif; color: #ed6113">Error Code: 404</h1>
    </div>
</div>
